(()=>{
 const reduced=matchMedia('(prefers-reduced-motion:reduce)'),instances=new Map();
 const clamp=value=>Math.max(0,Math.min(1,value));
 const smooth=value=>value*value*(3-2*value);
 let frame=0;
 function mount(chapter){
  if(instances.has(chapter))return;
  const panel=chapter.querySelector('.pad-coffee-scene'),stage=chapter.querySelector('.pad-cup-stage'),copy=chapter.querySelector('.pad-coffee-copy'),canvas=stage?.querySelector('canvas');
  if(!panel||!stage||!copy||!canvas)return;
  let prior=-1,priorMobile=null,keyboardCopy=false,presented=null,lastTime=0;
  const paint=()=>{
   const header=parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--pad-header-height'))||88;
   const mobile=innerWidth<=749;
   const sceneHeight=innerHeight-header;
   const contentFits=copy.scrollHeight+32<(mobile?sceneHeight*.46:sceneHeight);
   const enabled=chapter.dataset.revealEnabled!=='false'&&document.body.dataset.padMotion!=='false'&&!reduced.matches&&!window.Shopify?.designMode&&stage.hasAttribute('data-ready')&&sceneHeight>=(mobile?650:500)&&contentFits;
   chapter.toggleAttribute('data-reveal-active',enabled);
   const rect=chapter.getBoundingClientRect();
   const range=Math.max(1,Math.min(800,sceneHeight*.90));
   const raw=clamp((header-rect.top)/range);
   if(!panel.contains(document.activeElement))keyboardCopy=false;
   const target=!enabled?1:raw;
   const now=performance.now(),elapsed=Math.min(32,Math.max(1,now-lastTime));lastTime=now;
   // Smooth wheel steps without changing native scrolling; keep every part on one clock.
   if(presented===null||!enabled||rect.bottom<0||rect.top>innerHeight)presented=target;
   else presented+=(target-presented)*(1-Math.exp(-elapsed/115));
   if(Math.abs(target-presented)<.0001)presented=target;
   const timeline=presented;
   const progress=smooth(clamp(timeline/.68));
   const entering=timeline<1;
   if(entering)chapter.dataset.entering='true';else delete chapter.dataset.entering;
   chapter.dataset.scrollProgress=progress.toFixed(3);
   // Hold a full-screen canvas through the macro shot. Contract only after the
   // pullback has exposed the complete cup; use a fixed scroll range to avoid feedback.
   const compact=smooth(clamp((timeline-.52)/.43));
   if(enabled){
    const height=sceneHeight-(mobile?0:Math.max(0,sceneHeight-880))*compact;
    const width=innerWidth-(mobile?0:Math.max(0,innerWidth-1440))*compact;
    chapter.style.height=`${height+range}px`;
    panel.style.height=`${height}px`;panel.style.maxWidth=`${width}px`;
    stage.style.height=`${mobile?height*(1-.46*compact):height}px`;
   }else{
    chapter.style.removeProperty('height');panel.style.removeProperty('height');
    panel.style.removeProperty('max-width');stage.style.removeProperty('height');
   }
   const pull=smooth(clamp((progress-.10)/.70));
   const words=keyboardCopy?1:smooth(clamp(mobile?(timeline-.70)/.28:(timeline-.62)/.34));

   const clearance=mobile&&enabled?sceneHeight*.46*(1-compact):0;
   copy.style.setProperty('--cup-copy-travel',`${(clearance+72*(1-words)).toFixed(2)}px`);
   copy.style.setProperty('--cup-copy-clip',`${(100*(1-words)).toFixed(2)}%`);
   if(progress!==prior||mobile!==priorMobile){canvas.dispatchEvent(new CustomEvent('pad:cup-presentation',{detail:{progress,offsetX:mobile?0:-.38*pull}}));prior=progress;priorMobile=mobile;}
   if(presented!==target)update();
  };
  const focus=event=>{if(event.target.matches(':focus-visible')){keyboardCopy=true;paint();}};
  const blur=()=>{keyboardCopy=false;update();};
  const unavailable=()=>{prior=-1;paint();};
  panel.addEventListener('focusin',focus);
  panel.addEventListener('focusout',blur);
  stage.addEventListener('pad:cup-unavailable',unavailable);
  const resize=new ResizeObserver(update);resize.observe(copy);
  const ready=new MutationObserver(()=>{prior=-1;update();});ready.observe(stage,{attributes:true,attributeFilter:['data-ready']});
  instances.set(chapter,{paint,dispose(){resize.disconnect();ready.disconnect();panel.removeEventListener('focusin',focus);panel.removeEventListener('focusout',blur);stage.removeEventListener('pad:cup-unavailable',unavailable);for(const prop of ['--cup-copy-travel','--cup-copy-clip'])copy.style.removeProperty(prop);chapter.style.removeProperty('height');panel.style.removeProperty('height');panel.style.removeProperty('max-width');stage.style.removeProperty('height');stage.style.removeProperty('--cup-stage-travel');delete chapter.dataset.entering;delete chapter.dataset.scrollProgress;delete chapter.dataset.revealActive;}});
  paint();
 }
 function paint(){frame=0;instances.forEach(instance=>instance.paint());const hero=document.querySelector('[data-pad-hero-photo]');if(hero){const r=hero.getBoundingClientRect();hero.style.setProperty('--cafe-photo-shift',reduced.matches||document.body.dataset.padMotion==='false'?'0px':Math.max(-20,Math.min(20,-r.top*.035))+'px');}}
 function update(){if(!frame)frame=requestAnimationFrame(paint);}
 const mountAll=root=>{if(root.matches?.('[data-pad-cup-chapter]'))mount(root);root.querySelectorAll('[data-pad-cup-chapter]').forEach(mount);};
 mountAll(document);
 document.addEventListener('shopify:section:load',e=>{mountAll(e.target);update();});
 document.addEventListener('shopify:section:unload',e=>{for(const [root,instance] of instances)if(e.target===root||e.target.contains(root)){instance.dispose();instances.delete(root);}});
 document.addEventListener('shopify:section:reorder',update);
 addEventListener('scroll',update,{passive:true});addEventListener('resize',update,{passive:true});reduced.addEventListener('change',update);paint();
})();
